import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '../styles'

/**
 *
 * @param {number} size size icon
 * @param {string} color color hexadecimal
 * @returns {React.Component}
 */
const IcTableIcon = ({ size, color }) => {
  return (
    <Icon
      className="ic-table-icons material-icons tw-items-center tw-justify-center"
      size={size}
      color={color}
    >
      view_column
    </Icon>
  )
}

IcTableIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string
}

export default IcTableIcon
